import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchDirections } from "../../api/api";
import { fetchDirectionsSuccess, fetchDirectionsFailure } from "./directions";
import { FetchDirectionsParams } from "../../types/request";

type FetchDirectionsAction = {
  type: string;
  payload: FetchDirectionsParams
}

export function* handleFetchDirections(action: FetchDirectionsAction): SagaIterator {
  try {
    const data = yield call(fetchDirections, action.payload);
    yield put(fetchDirectionsSuccess(data));
  } catch (error) {
    yield put(fetchDirectionsFailure(error.message));
  }
}
